"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': '教程统计',
    'tutorial.statistics.details': '教程参与者和进度',
    'tutorial.statistics.subtitle': '选择教程以查看参与者进度。',
    'tutorial.statistics.tutorial': '教程',
    'tutorial.statistics.category': '分类',
    'tutorial.statistics.actions': '操作',
    'tutorial.statistics.viewParticipants': '查看参与者',
    'tutorial.statistics.search': '搜索',
    'tutorial.statistics.retry': '重试',
    'tutorial.statistics.refresh': '刷新',
    'tutorial.statistics.back': '返回教程列表',
    'tutorial.statistics.pagination': '教程分页',
    'tutorial.statistics.previous': '上一页',
    'tutorial.statistics.next': '下一页',
    'tutorial.statistics.participants': '参与者',
    'tutorial.statistics.participant': '参与者',
    'tutorial.statistics.identity': '参与者类型',
    'tutorial.statistics.registered': '注册用户',
    'tutorial.statistics.guest': '访客',
    'tutorial.statistics.currentStep': '上次保存的步骤',
    'tutorial.statistics.currentSection': '上次保存的章节',
    'tutorial.statistics.tasks': '已完成任务',
    'tutorial.statistics.progress': '进度',
    'tutorial.statistics.progressExplanation': '进度表示每位参与者已完成的教程任务百分比。保存的位置并不表示已完成。',
    'tutorial.statistics.notStarted': '没有保存的位置',
    'tutorial.statistics.noTasks': '无任务',
    'tutorial.statistics.emptyTutorials': '未找到教程。',
    'tutorial.statistics.emptyParticipants': '此教程尚无参与者。',
    'tutorial.statistics.loadFailed': '无法加载教程统计。',
    'tutorial.statistics.time_data': '参与者教程时间数据',
    'tutorial.statistics.viewTimeData': '查看时间数据',
    'tutorial.statistics.time': '章节用时',
};
